<template>
  <div class="billboardMsgPage">
    <van-loading size="24px" vertical v-if="showNonePage"
      >加载中...</van-loading
    >
    <div v-if="!showNonePage">
      <van-cell-group class="forestInput">
        <van-field
          v-model="baseData.type"
          readonly
          :label="$t('common.type') + '：'"
        />
        <van-field
          :value="baseData.address"
          readonly
          :label="$t('common.politicalTit') + '：'"
        />
        <van-field
          v-model="baseData.manger"
          readonly
          :label="$t('common.administratorTit') + '：'"
        />
        <van-field
          v-model="baseData.remarks"
          rows="3"
          autosize
          type="textarea"
          readonly
          :label="$t('common.explainTit') + '：'"
        />
      </van-cell-group>
      <p class="fgx"></p>
      <div class="description" v-if="baseData.info != ''">
        <h4>{{$t('common.descriptorTit')}}</h4>
        <p class="desMain" v-html="baseData.info"></p>
      </div>
      <p class="fgx" v-if="baseData.imgs != ''"></p>
      <div class="photo" v-if="baseData.imgs != ''">
        <h4>{{$t('common.photoTit')}}</h4>
        <div class="photoBox">
          <van-grid :column-num="4" class="commentImgs clearfix">
            <van-grid-item
              class="imgList lf"
              v-for="(imgItem, index) in baseData.imgs"
              :key="index"
              @click="Showswiper(index)"
            >
              <van-image fit="contain" v-if="imgItem" :src="`${imgItem}`" />
            </van-grid-item>
          </van-grid>
        </div>
      </div>
    </div>
    <van-image-preview
      v-model="swiperShow"
      :images="showImgs"
      :startPosition="swipercliclIndex"
      class="VanImgs"
    ></van-image-preview>
    <!-- 网络失败 -->
    <refresh-page v-if="refreshPage" />
  </div>
</template>
<script>
/*eslint-disable*/
const refreshPage = () => import("@/components/common/refreshPage");
// import { getToken } from "@/utils/common";
import { getDeviceType } from "@/common/getDeviceType/getDeviceType";
export default {
  name: "billboardMsg",
  data() {
    return {
      showNonePage: true,
      billboardId: "", //公示牌Id
      baseData: {},
      DetailInfo: "",
      imgs: [],
      imgList: [],
      showImgs: [], // 展示的img
      swiperShow: false,
      swipercliclIndex: 0,
      refreshPage: false, //网络失败
      clientType: "", //手机类型
    };
  },
  props: {
    param: {
      type: Object,
      default: () => {
        {
          return {};
        }
      },
    },
  },
  mounted() {
    document.title = "公示牌信息";
    this.clientType = getDeviceType();

    this.$nextTick(function () {
      this.billboardId = this.$route.query.commonId;
      if (this.billboardId == undefined) {
        this.billboardId = this.param.id;
      }
      this.initPage();
    });
  },
  components: {
    refreshPage,
  },
  methods: {
    initPage() {
      let _this = this;
      _this.$api.universal
        .geoBoard({
          objid: _this.billboardId,
        })
        .then((res) => {
          if (res.code == "1") {
            console.log(res.data);
            _this.showNonePage = false;
            _this.baseData = Object.assign({}, _this.baseData, res.data);
            if (_this.baseData.imgs == []) {
              _this.baseData.imgs = "";
            }
          } else {
            console.log(res.msg);
            _this.$toast(res.msg);
          }
        })
        .catch((err) => {
          this.finished = true;
          console.log(err);
        });
    },
    Showswiper(showIndex) {
      let magnifyList = this.baseData.imgs;
      // this.imgs.forEach(SelectBigImgs);
      // function SelectBigImgs(item, index) {
      //   magnifyList.push(item);
      // }
      // this.showImgs = magnifyList;
      // this.swipercliclIndex = showIndex;
      // this.swiperShow = true;
      let data = {
        showImgs: magnifyList,
        swipercliclIndex: showIndex,
        swiperShow: true,
      };
      this.$store.commit("setDataImgs", data);
    },
  },
  watch: {
    param: {
      handler: function () {
        let _this = this;
        _this.billboardId = _this.param.id;

        _this.initPage();
      },
      deep: true,
    },
  },
};
</script>
<style lang="less">
.billboardMsgPage {
  width: 100%;
  height: 100%;
  background-color: #f6f6f6;

  .forestInput {
    .van-cell {
      .van-field__label {
        color: #999;
        font-size: 14px;
      }

      .van-cell__value {
        .van-field__control {
          color: #333;
          font-size: 14px;
          text-align: right;
        }
      }

      .van-cell__title {
        width: 120px;
      }
    }

    .van-cell.lbStyle {
      .van-cell__title {
        width: 150px;
      }
    }
  }

  .fgx {
    width: 100%;
    height: 20px;
    background-color: #f6f6f6;
  }

  .description {
    background-color: #fff;
    border-top: 1px solid #ebedf0;
    border-bottom: 1px solid #ebedf0;
    padding: 10px 16px 20px 16px;

    h4 {
      font-size: 14px;
      color: #666;
    }

    p.desMain {
      margin-top: 10px;
      font-size: 12px;
      color: #666;

      img {
        width: 100%;
        height: 100%;
        margin: 0 auto;
        display: block;
      }
    }
  }

  .photo {
    padding: 10px 16px 20px 16px;
    background-color: #fff;
    h4 {
      font-size: 14px;
      color: #666;
    }

    .photoBox {
      .commentImgs {
        width: 100%;

        .imgList {
          .van-grid-item__content {
            padding: 8px 8px;
          }

          .van-grid-item__content::after {
            border-width: 0;
          }
        }
      }
    }
  }
}
</style>